import { BookingStates } from '../../../../constants/booking-states';
import { DEFAULT_DOES_CONTAIN_EMAIL_REGEX, doesContainEmail } from '../../../../utils/validate-email';
import { doesContainPhoneNumber } from '../../../../utils/validate-phone-number';

export const disintermediationHelper = {
  getConfig (bookingState, contactWarningGateEnabled, disintermediationGateEnabled, emailRegexConfig) {
    const isRelevantBookingState = bookingState !== BookingStates.ACCEPTED
      && bookingState !== BookingStates.ACTIVE
      && bookingState !== BookingStates.EXECUTED
      && bookingState !== BookingStates.HOST_UPDATE_REQUESTED
      && bookingState !== BookingStates.GUEST_UPDATE_REQUESTED;

    const isContactWarningEnabled = contactWarningGateEnabled && isRelevantBookingState;
    const isDisintermediationEnabled = disintermediationGateEnabled && isRelevantBookingState;
    const emailRegexString = emailRegexConfig?.email_regex || DEFAULT_DOES_CONTAIN_EMAIL_REGEX;

    return {
      isContactWarningEnabled,
      isDisintermediationEnabled,
      emailRegexString
    };
  },

  shouldShowDisintermediationModal (text, isEnabled, emailRegex) {
    return isEnabled && doesContainEmail(text, emailRegex);
  },

  shouldShowPhoneWarning (text, isEnabled, hasBeenDetected) {
    return isEnabled && doesContainPhoneNumber(text) && !hasBeenDetected;
  }
};
